import { render, staticRenderFns } from "./Monthly-Talks.vue?vue&type=template&id=a9d9e72e&"
import script from "./Monthly-Talks.vue?vue&type=script&lang=js&"
export * from "./Monthly-Talks.vue?vue&type=script&lang=js&"
import style0 from "./Monthly-Talks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VCol,VDialog,VImg,VProgressCircular,VRow,VSnackbar})
